import React from "react";
import { Table, Badge } from "react-bootstrap";
import { BASE_URL, formatarTamanho } from "./utils";

function TabelaArquivos({ arquivos }) {
  if (arquivos.length === 0) {
    return <p className="text-muted p-3 mb-0">Nenhum arquivo encontrado.</p>;
  }
  return (
    <Table striped bordered hover responsive size="sm" className="mb-0">
      <thead>
        <tr>
          <th>Tipo</th>
          <th>Documento</th>
          <th>Aditivo/Renovação</th>
          <th>Nome</th>
          <th>Tamanho</th>
        </tr>
      </thead>
      <tbody>
        {arquivos.map((a, idx) => (
          <tr key={`${a.id_documento}-${a.id_aditivo ?? "doc"}-${idx}`}>
            <td>
              <Badge
                bg={a.tipo === "aditivo" ? "info" : "secondary"}
                text={a.tipo === "aditivo" ? "dark" : undefined}
              >
                {a.tipo === "aditivo" ? "Aditivo" : "Documento"}
              </Badge>
            </td>
            <td>{a.id_documento ?? "—"}</td>
            <td>{a.id_aditivo ?? "—"}</td>
            <td>
              {a.path ? (
                <a
                  href={`${BASE_URL}/${a.path.replace(/^\//, "")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary text-decoration-none"
                  download
                >
                  {a.nome_real || a.path.replace(/^.*[/\\]/, "") || "—"}
                </a>
              ) : (
                a.nome_real || "—"
              )}
            </td>
            <td>{formatarTamanho(a.tamanho)}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

export default TabelaArquivos;
